<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂分析"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="451px">
      <el-form class="search-wrap"
               ref="formRules"
               :model="dataForm"
               :rules="rules"
               label-width="130px"
               label-position="left">
        <el-form-item label="指定院校："
                      prop="apply_college">
          <el-select v-model="dataForm.apply_college"
                     filterable
                     placeholder="请选择"
                     @change="apply_collegeChange"
                     style="width: 100%"
                     clearable>
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定专业："
                      prop="apply_major">
          <el-select v-model="dataForm.apply_major"
                     placeholder="请选择"
                     filterable
                     clearable
                     style="width: 100%"
                     @change="apply_majorChange">
            <el-option v-for="(item, index) in apply_majorList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定学习方式">
          <el-select v-model="dataForm.apply_enrol_type"
                     filterable
                     placeholder="请选择"
                     style="width: 100%"
                     clearable>
            <el-option v-for="(item, index) in learningOption"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer"
           class="footer">
        <el-button @click="handleClose()">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
        
  <script>
import { collegeMajorList, majorList } from '@/api/common'
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        apply_college: [
          { required: true, message: '请选择报考院校', trigger: 'blur' },
        ],
        apply_major: [
          { required: true, message: '请选择报考专业', trigger: 'blur' },
        ],
      },
      apply_majorList: [],

      learningOption: [
        {
          label: '全日制',
          value: '1',
        },
        {
          label: '非全日制',
          value: '2',
        },
      ],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  created() {},
  methods: {
    apply_collegeChange(e) {
      collegeMajorList({ college_code: e.value, isPaging: 0 }).then((res) => {
        this.apply_majorList = res.list
      })
    },
    apply_majorChange(e) {},
    handleClose() {
      this.$emit('close')
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          const data = {
            finger_college_code: this.dataForm.apply_college.value,
            finger_major_code: this.dataForm.apply_major.value,
            finger_enrol_type: this.dataForm.apply_enrol_type,
          }
          this.$emit('submit', { data: data })
          this.handleClose()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
  <style lang="less" scoped>
</style>
        